import { FC } from 'react'
import { PerModal } from '../../components/custom_components/Modal'
import { EmployeeDisplayTinyInfo } from '../../types'
import useTagHistoryOfEmployeeUntilReplyEntryDate from '../../graphql/ranking/hooks/useTagHistoryOfEmployeeUntilReplyEntryDate'
import { LoadingAndErrors } from '../../components/custom_components/LoadingAndErrors'
import { RankingTagHistoryModal } from './RankingTagHistoryModal'

type Props = {
  isOpen: boolean
  employee?: EmployeeDisplayTinyInfo
  onCancel: () => void
}

export const LazyRankingTagHistoryModal: FC<Props> = ({ employee, isOpen, onCancel }) => {
  const { data, error, loading } = useTagHistoryOfEmployeeUntilReplyEntryDate(!employee ? '' : employee.id)

  if (loading) {
    return <div></div>
  }

  if (!employee || error || !data || !data.tagHistoryOfEmployeeUntilReplyEntryDate) {
    return (
      <PerModal title={{ heading: 'Error' }} visible={isOpen} onCancel={onCancel} size="large">
        <LoadingAndErrors hasNoData={!data || !data.tagHistoryOfEmployeeUntilReplyEntryDate} isLoading={false} error={error} />
      </PerModal>
    )
  }
  return (
    <RankingTagHistoryModal
      isOpen={isOpen}
      onCancel={onCancel}
      modalData={data.tagHistoryOfEmployeeUntilReplyEntryDate}
      employee={employee}
    />
  )
}
